export default __webpack_public_path__ + "static/media/maxresdefault.4fced9eb.jpg";